export enum ActiveViews {
    default,
    addStandardInvoice,
    addAdhocInvoice,
    editStandardInvoice
}

export enum TemplateTypes {
    itemizedTable = "ItemizedTable",
    bulletPoints = "BulletPoints",
    paragraph = "Paragraph"
}

export enum ReceiptTemplateTypes {
    itemizedTable = "ItemizedTable",
    bulletPoints = "BulletPoints",
    paragraph = "Paragraph"
}